import { NgIf } from '@angular/common';
import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { DeviceDetectorService } from 'ngx-device-detector';

import { TooltipDirective } from '@/directives/tooltip/tooltip.directive';
import { RouterLink } from '@angular/router';

export enum RoundedLinkType {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM'
}

@Component({
  selector: 'app-rounded-link',
  templateUrl: './rounded-link.component.html',
  styleUrls: ['./rounded-link.component.scss'],
  standalone: true,
  imports: [RouterLink, MatIconModule, NgIf, TooltipDirective]
})
export class RoundedLinkComponent implements OnInit {
  @Input() color = 'primary';
  @Input() icon: string;
  @Input() tooltip: string;
  @Input() text: string;
  @Input() text2: string;
  @Input() showKpi = false;
  @Input() kpi: number;
  @Input() link: string | null = null;
  @Input() disabled = false;
  @Input() squareMode = false;
  @Input() type: RoundedLinkType = RoundedLinkType.MEDIUM;
  @Output() clickEvent = new EventEmitter<boolean>();

  @HostBinding('class.SMALL') cssSmall = false;
  @HostBinding('class.MEDIUM') cssMedium = false;

  kpiToShow: string;

  constructor(private deviceService: DeviceDetectorService) {}

  ngOnInit() {
    if (this.showKpi) {
      this.kpiToShow = this.kpi > 0 ? '' + this.kpi : '-';
    }
    if (!this.deviceService.isDesktop()) {
      // on mobile and tablet we disable the tooltip as it's not usable and disable the scroll capability
      this.tooltip = null;
    }
    if (this.type === RoundedLinkType.MEDIUM) {
      this.cssMedium = true;
    } else if (this.type === RoundedLinkType.SMALL) {
      this.cssSmall = true;
    }
  }

  doClick() {
    if (!this.disabled) {
      this.clickEvent.emit(true);
    }
  }
}
